import { render, staticRenderFns } from "./TeamRoleDialog.vue?vue&type=template&id=3140f6d2&scoped=true&"
import script from "./TeamRoleDialog.vue?vue&type=script&lang=ts&"
export * from "./TeamRoleDialog.vue?vue&type=script&lang=ts&"
import style0 from "./TeamRoleDialog.vue?vue&type=style&index=0&id=3140f6d2&prod&lang=scss&"
import style1 from "./TeamRoleDialog.vue?vue&type=style&index=1&id=3140f6d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3140f6d2",
  null
  
)

export default component.exports